export default "__VITE_ASSET__DBbsC9Gz__"